import React, { Component } from "react";
import firebase from "../../utils/firebase";
import moment from "moment";
import { Link } from "react-router-dom";

import MyTable from "../../components/myTable/MyTable";

import Select from "@atlaskit/select";
import Button from "@atlaskit/button";

import "./admin.css";

import { APPLICATION_STATUSES } from "../../utils/consts";
import { FieldTextStateless } from "@atlaskit/field-text";
import Tabs from "@atlaskit/tabs/dist/cjs/components/Tabs";

const statusItems = {
  items: Object.keys(APPLICATION_STATUSES).map(status => ({
    label: APPLICATION_STATUSES[status],
    value: APPLICATION_STATUSES[status]
  }))
};

export default class AdminApps extends Component {
  constructor() {
    super();

    this.state = {
      applications: [],
      status: undefined,
      lid: "",
      uid: ""
    };
  }

  statusSelectHandler = item => {
    if (!item) {
      this.setState({ status: undefined });
    } else {
      this.setState({ status: item.value });
    }
  };

  getApps = async param => {
    this.setState({ loading: true });
    try {
      const query = this.state[param];
      const applications = await firebase
        .firestore()
        .collection("application")
        .where(param, "==", query)
        .get()
        .then(querySnapshot => querySnapshot.docs)
        .then(docs => docs.map(doc => doc.data()));
      this.setState({
        applications,
        loading: false
      });
    } catch (error) {
      this.setState({ loading: false });
    }
  };

  fieldHandler = e => this.setState({ [`${e.target.name}`]: e.target.value });

  tabHandler = (tab, i) => this.setState({ tab: i });

  render() {
    return (
      <div className="admin-apps">
        <Tabs
          onSelect={this.tabHandler}
          selected={this.state.tab}
          tabs={[
            {
              label: "Status",
              content: (
                <div className="admin-search">
                  <Select
                    aria-label="application status select"
                    blurInputOnSelect
                    isClearable
                    className="application-admin__status-select"
                    appearance="default"
                    options={statusItems.items}
                    placeholder="Status..."
                    label="Application Status"
                    shouldFitContainer
                    droplistShouldFitContainer
                    hasAutocomplete
                    onChange={this.statusSelectHandler}
                  />
                  <Button
                    isLoading={this.state.loading}
                    className="admin-search__btn"
                    appearance="primary"
                    isDisabled={!this.state.status}
                    onClick={e => this.getApps("status")}
                  >
                    Search
                  </Button>
                </div>
              )
            },
            {
              label: "ListingID",
              content: (
                <div className="admin-search">
                  <FieldTextStateless
                    className="application-admin__lid-input"
                    onChange={this.fieldHandler}
                    name="lid"
                    value={this.state.lid}
                    aria-label="application listing ID"
                    blurInputOnSelect
                    isClearable
                    appearance="default"
                    placeholder="Listing ID..."
                    shouldFitContainer
                  />
                  <Button
                    isLoading={this.state.loading}
                    className="admin-search__btn"
                    appearance="primary"
                    isDisabled={!this.state.lid}
                    onClick={e => this.getApps("lid")}
                  >
                    Search
                  </Button>
                </div>
              )
            },
            {
              label: "UserID",
              content: (
                <div className="admin-search">
                  <FieldTextStateless
                    className="application-admin__uid-input"
                    onChange={this.fieldHandler}
                    name="uid"
                    value={this.state.uid}
                    aria-label="application User ID"
                    blurInputOnSelect
                    isClearable
                    appearance="default"
                    placeholder="User ID..."
                    shouldFitContainer
                  />
                  <Button
                    isLoading={this.state.loading}
                    className="admin-search__btn"
                    appearance="primary"
                    isDisabled={!this.state.uid}
                    onClick={e => this.getApps("uid")}
                  >
                    Search
                  </Button>
                </div>
              )
            }
          ]}
        />
        <div className="admin-results">
          <MyTable
            caption="Applications"
            head={{
              cells: [
                {
                  key: "lid",
                  content: (
                    <span className="applications-admin__table-header-cell">
                      LID
                    </span>
                  ),
                  isSortable: true,
                  width: 50,
                  shouldTruncate: true
                },
                {
                  key: "rentOffer",
                  content: (
                    <span className="applications-admin__table-header-cell">
                      Offer
                    </span>
                  ),
                  isSortable: true,
                  width: 50,
                  shouldTruncate: true
                },
                {
                  key: "moveInDate",
                  content: (
                    <span className="applications-admin__table-header-cell">
                      Move In
                    </span>
                  ),
                  isSortable: true,
                  width: 50,
                  shouldTruncate: true
                },
                {
                  key: "user",
                  content: (
                    <span className="applications-admin__table-header-cell">
                      User
                    </span>
                  ),
                  isSortable: true,
                  width: 50,
                  shouldTruncate: true
                },
                {
                  key: "date",
                  content: (
                    <span className="applications-admin__table-header-cell">
                      Updated
                    </span>
                  ),
                  isSortable: true,
                  width: 50,
                  shouldTruncate: true
                }
              ]
            }}
            rows={this.state.applications.map((application, i) => {
              return {
                key: `applications-admin__row_${i}`,
                cells: [
                  {
                    key: `lid`,
                    content: (
                      <Link
                        className="table-row-link"
                        to={`/listing/${application.lid}`}
                      >
                        {application.lid}
                      </Link>
                    )
                  },
                  {
                    key: `rentOffer`,
                    content: <span>${application.rentOffer}</span>
                  },
                  {
                    key: `moveInDate`,
                    content: (
                      <span>
                        {moment(application.moveInDate).format("MMM Do")}
                      </span>
                    )
                  },
                  {
                    key: `user`,
                    content: (
                      <Link
                        className="table-row-link"
                        to={`/application/${application.uid}`}
                      >
                        <span>{application.uid}</span>
                      </Link>
                    )
                  },
                  {
                    key: `date`,
                    content: (
                      <span>
                        {moment(application.updated.toDate()).format("MMM Do")}
                      </span>
                    )
                  }
                ]
              };
            })}
            emptyView={<span>No Applications</span>}
            loading={this.state.loading}
          />
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/admin/AdminApps.js